
export const ACTION_TYPE_SET_COVER_PRESENT = "ACTION_TYPE_SET_COVER_PRESENT";
export const ACTION_TYPE_SET_LIGHT_NAV = "ACTION_TYPE_SET_LIGHT_NAV";

export default function setCoverPresent(payload) {
  return { type: ACTION_TYPE_SET_COVER_PRESENT, payload }
};

export function setLightNav(payload) {
  return { type: ACTION_TYPE_SET_LIGHT_NAV, payload }
};
